import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { useFormContext } from 'framework/form';
import { COMPLIANCE_DOCUMENT_STATUS } from 'domain/shared/compliance';

const ViewComplianceDocumentModalActions = ({ onCloseModal }: { onCloseModal: () => void }) => {
  const { data: formData } = useFormContext();
  const { status } = formData || {};
  const { isSubmitEnabled, isLoadingArtifact, submitForm, onChangeCallback } = useFormContext();
  const [submitting, setSubmitting] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const initStatus = useMemo(() => status, []);

  useEffect(() => {
    if (submitting && submitForm) {
      submitForm();
      setSubmitting(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitting]);

  const publishMethod = async (newStatus: string) => {
    if (onChangeCallback) {
      onChangeCallback({ status: newStatus });
      setSubmitting(true);
    }
  };

  return (
    <Box display="flex" gap="10px">
      {initStatus !== COMPLIANCE_DOCUMENT_STATUS.PUBLISHED ? (
        <Button
          color="secondary"
          onClick={() => publishMethod(COMPLIANCE_DOCUMENT_STATUS.PUBLISHED)}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Publish
        </Button>
      ) : (
        <Button
          data-testid="submit-button"
          onClick={() => publishMethod(COMPLIANCE_DOCUMENT_STATUS.UNPUBLISHED)}
          disabled={!isSubmitEnabled || isLoadingArtifact}
          variant="outlined"
        >
          Unpublish
        </Button>
      )}

      <Button data-testid="cancel-btn" variant="outlined" type="button" onClick={onCloseModal}>
        Cancel
      </Button>
    </Box>
  );
};

export default ViewComplianceDocumentModalActions;
